import React, { useState } from "react";
import Nestora from "../images/Nestora.png";
import { Facebook, Chrome, Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { auth , db } from "../components/Firebase";
import { toast, ToastContainer } from "react-toastify";
import { setDoc , doc } from "firebase/firestore";

const Registration = () => {
  const [signup, setSignUp] = useState(false);
  const [email, setEmail] = useState("");
  const [username, setUserName] = useState("");
  const [pasword, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const handleSignIn = async (e) => {
    e.preventDefault();
    console.log("signIN");
    try {
      await signInWithEmailAndPassword(auth , email , pasword);
      console.log("login successful")
      window.location.href = "/mainpage";
      setEmail('');
      setPassword('');
    } catch (error) {
      toast.error(`${error.message}`, { position: "top-center" });
    }
  };
  const handleSignUp = async (e) => {
    e.preventDefault();
    console.log("signup");
    try {
      await createUserWithEmailAndPassword(auth, email, pasword);
      const user = auth.currentUser;
      console.log(user);
      if(user){
        await setDoc(doc(db , "Users", user.uid), {
          email : user.email,
          username : username,
          phonenumber : phoneNumber
        });
      }
      toast.success("Successfully created Account", { position: "top-center" });
      window.location.href = "/mainpage";
      setUserName('');
      setEmail('');
      setPassword('');
      setPhoneNumber('');
      
    } catch (error) {
      console.log(error);
      
      toast.error(`${error.message}`, { position: "top-center" });
    }
  };
  return (
    <div className="flex justify-center items-center  min-h-[100vh] bg-slate-50">
      <form
        className=" w-[400px] p-6 rounded-lg bg-white drop-shadow-sm"
        onSubmit={signup ? handleSignUp : handleSignIn}
      >
        <div className="flex items-center gap-[-2px] ">
          <img src={Nestora} alt="Nestora" className="w-[60px] h-[60px]"></img>
          <p className="text-md font-medium">Nestora</p>
        </div>
        <div className="flex justify-evenly items-center border rounded-lg ">
          <button
            type="button"
            className={` flex-1 p-1 rounded-lg ${
              signup ? "text-blue-700 bg-white" : "bg-blue-700 text-white"
            }`}
            onClick={() => setSignUp(!signup)}
          >
            Sign-In
          </button>
          <button
            type="button"
            className={`flex-1 p-1 rounded-lg ${
              signup ? "bg-blue-700 text-white" : "bg-white text-blue-700"
            }`}
            onClick={() => setSignUp(!signup)}
          >
            Sign-Up
          </button>
        </div>
        <div>
          <h2 className="text-xl mt-3">Welcome to Nestora</h2>
          <p className="text-sm text-gray-500">
            Please {signup ? "sign-up your account" : "sign-in to your account"}{" "}
            and start decorating your home
          </p>
        </div>
        {signup && (
          <div className="flex flex-col items-start gap-1 mb-2">
            <label className="uppercase  text-md ">UserName </label>
            <input
              value={username}
              className="border-2 w-[100%] h-5 pl-2 pt-4 pb-4 placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-violet-500 outline-none"
              placeholder="Enter your Name"
              onChange={(e) => setUserName(e.target.value)}
              required
            ></input>
          </div>
        )}
        {signup ? (
          <div>
            <div className="flex flex-col items-start gap-1 mb-2">
              <label className="uppercase  text-md ">Phone No</label>
              <input
                value={phoneNumber}
                className="border-2 w-[100%] h-5 pl-2 pt-4 pb-4 placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-violet-500 outline-none"
                placeholder="Enter your  Phone No"
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              ></input>
            </div>
            <div className="flex flex-col items-start gap-1 mb-2">
              <label className="uppercase  text-md ">Email</label>
              <input
                value={email}
                className="border-2 w-[100%] h-5 pl-2 pt-4 pb-4 placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-violet-500 outline-none"
                placeholder="Enter your mail "
                onChange={(e) => setEmail(e.target.value)}
                required
              ></input>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-start gap-1 mb-2">
            <label className="uppercase  text-md ">Email or Phone No</label>
            <input
              value={email}
              className="border-2 w-[100%] h-5 pl-2 pt-4 pb-4 placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-violet-500 outline-none"
              placeholder="Enter your mail or Phone No"
              onChange={(e) => setEmail(e.target.value)}
              required
            ></input>
          </div>
        )}
        <div className="flex flex-col items-start gap-1 mb-2 relative">
          <label className="uppercase  ">Password</label>
          {!signup && (
            <Link to="/forgotpassword" className="absolute right-0 text-sm text-blue-700 hover:underline top-2">
              Forgot Password?
            </Link>
          )}
          <input
            value={pasword}
            className="border-2 w-[100%] h-5 pl-2 pt-4 pb-4 placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-violet-500 outline-none"
            placeholder="Password"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            required
          ></input>
        </div>
        <div className="flex items-center  mb-2">
          <input type="checkbox" required></input>
          <label>Remember Me</label>
        </div>
        <div className="flex flex-col items-start gap-1 mb-2">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 transition-colors duration-400Z w-full  pt-2 pb-2 rounded-lg text-white"
          >
            {signup ? "sign-up" : "sign-in"}
          </button>
          {signup ? (
            <p className="text-gray-500">
              Have an account ?{" "}
              <Link className="text-blue-700 hover:underline" onClick={()=>setSignUp(false)}>Login</Link>
            </p>
          ) : (
            <p className="text-gray-500">
              New to our Platform ?{" "}
              <Link  className="text-blue-700 hover:underline" onClick={()=>setSignUp(true)}>
                Create an account
              </Link>
            </p>
          )}
        </div>
        <div className="flex items-center">
          <p className="flex-1 h-[1px] bg-blue-500"></p>
          <p className="flex-[0.5] text-center">or</p>
          <p className="flex-1 h-[1px] bg-blue-500"></p>
        </div>
        <div className="flex items-center justify-center gap-4 mt-3">
          <span className="w-10 h-10 bg-violet-400/40 rounded-md flex items-center justify-center">
            <Link>
              <Facebook className="text-black/0 fill-violet-700 w-6 h-6"></Facebook>
            </Link>
          </span>
          <span className="w-10 h-10 bg-red-400/40 rounded-md flex items-center justify-center">
            <Link>
              <Chrome className="text-red-700 w-6 h-6" />
            </Link>
          </span>
          <span className="w-10 h-10 bg-blue-400/40 rounded-md flex items-center justify-center">
            <Link>
              <Twitter className="text-black/0 fill-blue-700 w-6 h-6" />
            </Link>
          </span>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
};

export default Registration;
